import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=85078158&functional=true&"
import script from "./IconRefresh.vue?vue&type=script&lang=js&"
export * from "./IconRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports